import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_215: DocMigration = {
  maxSchemaVersion: "0.0.215",
  description: "Migrate facade material rotation to material transformations",
  apply(json: any) {
    for (const facadeId in json.facades) {
      const facade = json.facades[facadeId];
      for (const spanStratum of facade.spanStrata) {
        if (spanStratum.materialRotation) {
          const rotation: number = spanStratum.materialRotation;
          spanStratum.materialTransformation = {
            rotationDegrees: rotation,
            uTranslation: 0,
            vTranslation: 0,
          };
          delete spanStratum.materialRotation;
        }
      }
      for (const sweepStratum of facade.sweepStrata) {
        if (sweepStratum.materialRotation) {
          const rotation: number = sweepStratum.materialRotation;
          sweepStratum.materialTransformation = {
            rotationDegrees: rotation,
            uTranslation: 0,
            vTranslation: 0,
          };
          delete sweepStratum.materialRotation;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_215;
